import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { GroupsService } from '@shared/services/groups.service';
import { LoadingState } from '@shared/types/loading-state';
import { Observable } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-custom-email',
  templateUrl: './custom-email.component.html',
  styleUrls: ['./custom-email.component.scss'],
  standalone: false,
})
export class CustomEmailComponent implements OnInit {
  @Input() groupId?: string = '';
  @Input() defaultEmail: string = '';
  @Input() emailBody: string;
  @Input() subject: string = '';
  @Input() subjectEditable: boolean = false;
  @Input() infoText: string = '';
  @Input() opportunityId?: number;
  @Input() leadId?: number;
  @Input() nextStepEnabled: boolean = true;

  emailInputForm: FormGroup;
  loadingState$: Observable<LoadingState>;
  salesEmail: string = environment.contact_details.sales_email;
  groupName: string = '';
  nextStepForm: FormGroup;

  constructor(
    private modalController: ModalController,
    private groupService: GroupsService,
  ) {}

  ngOnInit(): void {
    this.emailInputForm = new FormGroup({
      from_address: new FormControl(this.salesEmail, [Validators.email]),
      email_addresses: new FormControl(this.defaultEmail, [Validators.required]),
      subject: new FormControl(this.subject || '', [Validators.required]),
      body: new FormControl(this.emailBody || '', [Validators.required, Validators.pattern(/\S/)]),
    });

    this.nextStepForm = new FormGroup({
      description: new FormControl('', [Validators.minLength(3)]),
      due_date: new FormControl(''),
    });

    if (this.groupId) {
      this.groupService.loadGroup(this.groupId);
      this.groupService
        .getGroup(this.groupId)
        .pipe(
          skipWhile((group) => !group),
          take(1),
        )
        .subscribe((group) => {
          this.groupName = group?.attributes?.name || '';
          this.defaultEmail =
            group?.attributes?.contacts?.find((contact) => contact.contact_roles?.some((role) => role === 'primary'))
              ?.email || this.defaultEmail;
          this.emailInputForm.patchValue({ email_addresses: this.defaultEmail });
        });

      this.loadingState$ = this.groupService.getGroupsLoading();
    }
  }

  onEmailsUpdate(email_addresses: string[]) {
    this.emailInputForm.controls['email_addresses'].setValue(email_addresses.join(','));
  }

  sendEmail() {
    this.emailInputForm.markAllAsTouched();
    this.nextStepForm.markAllAsTouched();
    if (this.emailInputForm.invalid || this.nextStepForm.invalid) return;

    this.modalController.dismiss({
      email_addresses: this.emailInputForm.controls['email_addresses'].value
        .split(',')
        .map((email: string) => email.trim()),
      subject: this.emailInputForm.controls['subject'].value,
      body: this.emailInputForm.controls['body'].value,
      from_address: this.emailInputForm.controls['from_address'].value,
      next_step: !!this.nextStepForm.value.description
        ? {
            description: this.nextStepForm.controls['description'].value,
            due_date: this.nextStepForm.controls['due_date'].value,
          }
        : null,
    });
  }

  dismissModal() {
    this.modalController.dismiss({});
  }
}
